import { render } from "./AddForms.vue?vue&type=template&id=58d35762"
import script from "./AddForms.vue?vue&type=script&lang=js"
export * from "./AddForms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__